import React, { useState } from 'react'

const ProductFeaturesList = ({ id, list }) => {
	const [active, setActive] = useState('1')

	function toggleFeature(param) {
		setActive(param)
	}

	return (
		<ul className="productFeatures_list" key={id}>
			{list.map((item) => (
				<li
					role="button"
					tabIndex={item.id}
					key={item.id}
					onClick={() => toggleFeature(item.id)}
					onKeyDown={() => toggleFeature(item.id)}
					className={`productFeatures_listItem ${
						active === item.id && 'active'
					}`}
				>
					<div className={`productFeatures_listTitle`}>
						<div className="productFeatures_listTitleIcon">{item.icon}</div>
						<h3 className="productFeatures_listTitleText">{item.title}</h3>
					</div>

					<div
						className={`productFeatures_listDescription ${
							active === item.id && 'active'
						}`}
					>
						{item.description}
					</div>
				</li>
			))}
		</ul>
	)
}

export default ProductFeaturesList
